import React, {useState} from "react"; // Keep it here for React to Work.
import { Link } from 'react-router-dom';
import {Icon} from 'react-icons-kit';
import {eyeOff} from 'react-icons-kit/feather/eyeOff';
import {eye} from 'react-icons-kit/feather/eye';
import { useNavigate } from 'react-router-dom';

import LogoJFZ_signatureWhite from "../../../assets/jfz-white-transparent.png";
import LoggWholeheardedGlobalTransparent from "../../../assets/logo-wholehearted-global-transparent.png";
import HtmlTagName from "../../../utils/stringLiterals/HtmlTagName";
import SessionManager from "../../../businessLayer/managers/SessionManager";
import JsTypeInspector from "../../../serviceLayer/validators/JsTypeInspector";
import ValidationService from "../../../serviceLayer/validators/ValidationService";
import HttpStatusCode from "../../../utils/httpProtocol/HttpStatusCode";
import ProcessStatus from "../../../utils/enumerations/ProcessStatus";
import SessionService from "../../../serviceLayer/session/SessionService";


export default function Login(){
    const navigate = useNavigate();
    const[emailErrors, setEmailErrors] = useState("");
    const[passwordErrors, setPasswordErrors] = useState("");
    const[loginErrors, setLoginErrors] = useState(""); 
    const [type, setType] = useState(HtmlTagName.PASSWORD);
    const [icon, setIcon] = useState(eyeOff);

    function onButtonClickEvent(e){  
        setEmailErrors("");
        setPasswordErrors("");
        setLoginErrors("");
        //console.log("onButtonClickEvent-event: ", e);
        e.preventDefault();
        
        const report = SessionManager.grantAccess(loginUserCallback);
        //console.log("grantAccess-report", report);
        const reportIsValid = JsTypeInspector.objectIsValid(report); 
        if(reportIsValid &&  report.status === ProcessStatus.FailedWithErrors){
            processEmailErrors(report);
            processPasswordErrors(report);
        }
    }

    function togglePasswordVisibility(){
        if (type=== HtmlTagName.PASSWORD ){
            setIcon(eye);
            setType(HtmlTagName.TEXT )
        } else {
            setIcon(eyeOff)
            setType( HtmlTagName.PASSWORD )
        }
    }

    function onBlurEvent(event){
        event.preventDefault();
        //console.log("onBlurEvent-event", event);
        clearInputs(event.target.name);
    }

    function onInputChangeEvent(event){
        event.preventDefault();
        //console.log("onInputChangeEvent-event", event);
        clearInputs(event.target.name);
    }

    function startSession(){
        const newSession = SessionService.createNewSessionData();
        SessionService.saveSessionData(newSession);
    }

    //#region Private Functions BEGIN
    function processEmailErrors(reportObj){
        const report = ValidationService.processErrors(reportObj, HtmlTagName.EMAIL);
        setEmailErrors(report); 
    }

    function processPasswordErrors(reportObj){
        const report = ValidationService.processErrors(reportObj, HtmlTagName.PASSWORD);
        setPasswordErrors(report);
    }

    function processLoginErrors(reportObj){
        const report = ValidationService.processErrors(reportObj, HtmlTagName.LOGIN )
        setLoginErrors(report);
    }

    function clearInputs(inputName){

        if(inputName === HtmlTagName.EMAIL){
            setEmailErrors("");
        }
        if(inputName === HtmlTagName.PASSWORD){
            setPasswordErrors("");
        }
        setLoginErrors("");
    }

    function loginUserCallback(httpResponse){
        //console.log("loginUserCallback-httpResponse", httpResponse);
        if(httpResponse.code === HttpStatusCode._200ok.code){

            startSession();
            return navigate('/private/main');
        }

        if(httpResponse.code === HttpStatusCode._400badRequest.code){
            processEmailErrors(httpResponse.payload);
            processPasswordErrors(httpResponse.payload);
        }      

        if(httpResponse.code === HttpStatusCode._401unauthorized.code){
            processLoginErrors(httpResponse.payload);
        }

        if(httpResponse.code === HttpStatusCode._500InternalServerError.code){
            setLoginErrors(httpResponse.payload.errorMessage);
        }
    }
    //#region Private Functions END  

    return(
        <div className="app-container"><div className="header login-header-section">Login</div>
            <div className="nav-bar-container-flex"></div>
            <div className="logo">                  
                <img src={LoggWholeheardedGlobalTransparent}  alt="logo_wholehearted_global" className="logo-wholehearted-public"/>
            </div>
            <span className="error-message" name={HtmlTagName.LOGIN} dangerouslySetInnerHTML={{ __html: loginErrors }}></span>
            <form id="loginCustomerForm1" className="form-flex">
                <input id="email1" 
                        type={HtmlTagName.EMAIL} 
                        name={HtmlTagName.EMAIL} 
                        onChange={onInputChangeEvent} 
                        onBlur={onBlurEvent}
                        placeholder="Email" 
                        className="input-field input-h45"
                />
                <span className="error-message" dangerouslySetInnerHTML={{ __html: emailErrors }}></span>
                <div className="password-container">
                    <input id="password1" 
                            type={type}
                            name={HtmlTagName.PASSWORD}
                            onChange={onInputChangeEvent} 
                            onBlur={onBlurEvent}
                            placeholder="Password" 
                            className="input-field input-h45 password-field"
                    />
                    <span className="toggle-icon" onClick={togglePasswordVisibility}>
                        <Icon className="mr-10" icon={icon} size={25}/>
                    </span>
                </div>
                
                <span className="error-message" dangerouslySetInnerHTML={{ __html: passwordErrors }}></span>
                <button type="button" className="btn-element login-btn" onClick={(e)=>{onButtonClickEvent(e);}}>Login</button>
            </form>
            <span className="position-rel basic-message-white left--5perc"> Dont Have an Account?</span>
            <Link to="/public/registration" className="position-rel basic-message-lightorange left-5perc">Register Here</Link>
            <div className="bottom flex-column-items-center">               
                <div className="signature-logo">                  
                    <img src={LogoJFZ_signatureWhite}  alt="logo_jfz_signature" className=""/>
                </div>
            </div>
        </div>
    );
};